import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../api/client";

// POST /api/v1/logout-everywhere deletes every session row for the user
// (including the current one). On success we mirror useSignOut: drop
// /me from the cache and bounce to /login. The orchestrator returns
// {sessions_deleted}; we don't surface the count today (no obvious place
// for it) but keep it on the response in case a future toast wants it.
export function useSignOutEverywhere() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      const { data, error } = await apiClient.POST("/api/v1/logout-everywhere", {
        params: { header: { "X-Requested-With": "xhr" } },
      });
      if (error) throw error;
      return data;
    },
    onSettled: () => {
      // Same shape as useSignOut: even on failure, clear local auth state
      // and bounce — a stale-but-still-valid cookie just means the user
      // re-signs-in once.
      queryClient.setQueryData(["me"], null);
      queryClient.invalidateQueries();
      navigate("/login", { replace: true });
    },
  });
}
